const PRODUCT_TYPE_GET_LIST_REQUEST = 'PRODUCT_TYPE_GET_LIST_REQUEST';
const PRODUCT_TYPE_GET_LIST_SUCCESS = 'PRODUCT_TYPE_GET_LIST_SUCCESS';
const PRODUCT_TYPE_GET_LIST_FAILURE = 'PRODUCT_TYPE_GET_LIST_FAILURE';

export default {
  PRODUCT_TYPE_GET_LIST_REQUEST,
  PRODUCT_TYPE_GET_LIST_FAILURE,
  PRODUCT_TYPE_GET_LIST_SUCCESS,
};
